export { CUSTOMER_TYPES, } from '../plugins/commonTypes/CommonTypes';
